/* tslint:disable */
/* eslint-disable */
/* @relayHash 7ae5e71791620cfcba8a23ad0596dadd */

import { ConcreteRequest } from "relay-runtime";
export type COMMENT_FLAG_REPORTED_REASON = "COMMENT_REPORTED_ABUSIVE" | "COMMENT_REPORTED_BIO" | "COMMENT_REPORTED_OFFENSIVE" | "COMMENT_REPORTED_OTHER" | "COMMENT_REPORTED_SPAM" | "%future added value";
export type CreateCommentFlagInput = {
    commentID: string;
    commentRevisionID: string;
    reason: COMMENT_FLAG_REPORTED_REASON;
    additionalDetails?: string | null;
    clientMutationId: string;
};
export type CreateCommentFlagMutationVariables = {
    input: CreateCommentFlagInput;
};
export type CreateCommentFlagMutationResponse = {
    readonly createCommentFlag: {
        readonly comment: {
            readonly id: string;
            readonly viewerActionPresence: {
                readonly flag: boolean;
            } | null;
        } | null;
        readonly clientMutationId: string;
    };
};
export type CreateCommentFlagMutation = {
    readonly response: CreateCommentFlagMutationResponse;
    readonly variables: CreateCommentFlagMutationVariables;
};



/*
mutation CreateCommentFlagMutation(
  $input: CreateCommentFlagInput!
) {
  createCommentFlag(input: $input) {
    comment {
      id
      viewerActionPresence {
        flag
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateCommentFlagPayload",
            "kind": "LinkedField",
            "name": "createCommentFlag",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActionPresence",
                            "kind": "LinkedField",
                            "name": "viewerActionPresence",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flag",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateCommentFlagMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateCommentFlagMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "7ae5e71791620cfcba8a23ad0596dadd",
            "metadata": {},
            "name": "CreateCommentFlagMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '9068361f37bd69f339c6d2302ae3b9f6';
export default node;
